import AOS from 'aos'; // https://github.com/michalsnik/aos

document.addEventListener('DOMContentLoaded', () => {
  AOS.init({ disable: 'mobile' });
});
